import * as angular from "angular";

const topics = [
  'action.service.assigned',
  'action.service.reset',
  'action.service.canceled',
  'action.service.aborted',
  'action.service.routed',
  'action.service.started',
  'action.service.completed',
  'entity.route.created',
  'entity.route.updated',
  'action.route.deleted',
  'action.route.assigned',
  'action.route.reset',
  'action.route.complete',
  'action.route.started',
  'entity.vehicle.created',
  'entity.vehicle.updated',
  'entity.agent.created',
  'entity.agent.updated',
  'entity.agent.location.updated',
  'entity.account.created',
  'entity.account.updated',
  'entity.depot.created',
  'entity.depot.updated',
  'entity.allocation.created',
  'entity.allocation.updated',
  'entity.allocation.timeWindow.created',
  'entity.allocation.timeWindow.updated',
  'entity.scheduleBinding.created',
  'entity.scheduleBinding.updated',
  'entity.service.created',
  'entity.service.updated',
  'entity.branch.created',
  'entity.branch.updated',
  'oms.order.updated',
  'oms.order.created',
  'oms.order.completed'
];

const statuses = [
  'Active',
  'Disabled'
]

angular
  .module('bringoz.admin.webhooks')
  .constant('WebhooksConstants', {
    topics: topics,
    statuses: statuses
  });
